import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CORE_PAGES } from "@/data/corePages";
import { LOCATIONS } from "@/data/locations";
import { GROUP_SIZES } from "@/data/groupSizes";
import { INTENTS } from "@/data/intents";
import { AUDIENCES } from "@/data/audiences";
import { FORMATS } from "@/data/formats";
import { COMPARISONS } from "@/data/comparisons";
import { COMMERCIAL } from "@/data/commercial";
import LandingPage from "@/pages/LandingPage";
import { GuidesIndex, GuideArticle } from "@/pages/Guides";
import { PoptavkaPage, ThankYouPage } from "@/pages/Poptavka";
import { AdminLogin, AdminLeads } from "@/pages/Admin";
import SeoAudit from "@/pages/SeoAudit";
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";

const ALL_LANDING = [...Object.values(CORE_PAGES), ...LOCATIONS, ...GROUP_SIZES, ...INTENTS, ...AUDIENCES, ...FORMATS, ...COMPARISONS, ...COMMERCIAL];

// Samostatný export pro SSG (scripts/prerender.js renderuje přes StaticRouter).
export const AppRoutes = () => (
  <Routes>
    {ALL_LANDING.map((p) => (
      <Route key={p.path} path={p.path} element={<LandingPage page={p} />} />
    ))}
    <Route path="/pruvodce" element={<GuidesIndex />} />
    <Route path="/pruvodce/:slug" element={<GuideArticle />} />
    <Route path="/poptavka" element={<PoptavkaPage />} />
    <Route path="/dekujeme" element={<ThankYouPage />} />
    <Route path="/admin/login" element={<AdminLogin />} />
    <Route path="/admin/leads" element={<AdminLeads />} />
    <Route path="/admin/seo-audit" element={<SeoAudit />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

// GA4 page_view pro SPA navigaci (config má send_page_view: false).
const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageViewTracker />
        <AppRoutes />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
